import { z } from "zod";

import { constantsData } from "@/data";

export const transactionFormSchema = z.object({
    currency: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    date: z.date().refine(
        (date) => date !== null && date !== undefined,
        { message: constantsData.msgs.requiredField },
    ),
    description: z.string().optional(),
    status: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
});
